import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";

export const verifications = (api: API) => ({
  searchForCompanies(
    country: string,
    companyNumber: string,
    companyName: string,
    forType: string,
    forId: string,
    success: (
      data: OpenAPI.GET<"/verifications/companies/search">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/verifications/companies/search?country=${country}&companyNumber=${companyNumber}&companyName=${encodeURIComponent(companyName)}&forType=${forType}&forId=${forId}`,
      null,
      success,
      fail,
    );
  },
  createReport(
    data: OpenAPI.POST<"/verifications/companies/reports">["requestBody"],
    success: (
      data: OpenAPI.POST<"/verifications/companies/reports">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    const { id, forType, forId, templatedFieldId } = data;
    api.authenticatedRequest(
      "POST",
      "/verifications/companies/reports",
      { id, forType, forId, templatedFieldId: templatedFieldId || null },
      success,
      fail,
    );
  },
  getReports(
    success: (
      data: OpenAPI.GET<"/verifications/companies/reports">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      "/verifications/companies/reports",
      null,
      success,
      fail,
    );
  },
});
